import Api from "./api";

class Dashboards extends Api {
  constructor(subPaths: string) {
    super(`dashboards${subPaths}`);
  }
}

export default Dashboards;
